var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRecord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7917 10.4167C13.2874 10.4167 14.5 9.2041 14.5 7.70833C14.5 6.21256 13.2874 5 11.7917 5C10.2959 5 9.08333 6.21256 9.08333 7.70833C9.08333 9.2041 10.2959 10.4167 11.7917 10.4167ZM11.7917 10.4167H4.20833M4.20833 10.4167C5.7041 10.4167 6.91667 9.2041 6.91667 7.70833C6.91667 6.21256 5.7041 5 4.20833 5C2.71256 5 1.5 6.21256 1.5 7.70833C1.5 9.2041 2.71256 10.4167 4.20833 10.4167Z",
    stroke: "currentColor",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecord);
export default __webpack_public_path__ + "static/media/icon-record.364e7b2567975f56cfb6986e3e5692bd.svg";
export { ForwardRef as ReactComponent };